import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

/* Last-resort error boundary. Deliberately styled with hardcoded values (no theme
   import) so it still renders when anything else is broken. */
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, info: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { this.setState({ info }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", background: "#0d1120", color: "#e8e6df",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "Georgia, serif", padding: 24 }}>
        <div style={{ maxWidth: 440, textAlign: "center" }}>
          <div style={{ fontSize: 24, marginBottom: 10 }}>Something went wrong</div>
          <div style={{ fontSize: 14.5, opacity: 0.75, lineHeight: 1.6, marginBottom: 18 }}>
            The page hit an unexpected error. Reloading usually fixes it — if it keeps
            happening, please let us know what you were doing when it broke.
          </div>
          <button onClick={() => location.reload()}
            style={{ background: "#b08d4f", color: "#0d1120", border: "none",
              borderRadius: 6, padding: "10px 22px", fontSize: 14, cursor: "pointer" }}>
            Reload the page
          </button>
          <div style={{ fontSize: 11, opacity: 0.45, marginTop: 16, textAlign: "left",
            fontFamily: "ui-monospace, monospace", wordBreak: "break-word",
            whiteSpace: "pre-wrap", maxHeight: 180, overflow: "auto" }}>
            {String(this.state.error)}
            {this.state.error?.stack ? "\n" + String(this.state.error.stack).split("\n")
              .slice(1, 4).join("\n") : ""}
            {this.state.info?.componentStack ? "\ncomponent:" + String(this.state.info
              .componentStack).split("\n").filter(Boolean).slice(0, 3).join(" <") : ""}
          </div>
        </div>
      </div>
    );
  }
}

createRoot(document.getElementById("root")).render(
  <ErrorBoundary><App /></ErrorBoundary>
);
